import { useSyncExternalStore } from "react";

const subscribeNoop = () => () => {};
const getClientTrue = () => true;
const getServerFalse = () => false;

export function useHydrated(): boolean {
  return useSyncExternalStore(subscribeNoop, getClientTrue, getServerFalse);
}
